import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  TextField,
} from "@material-ui/core";
import { Field, Formik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBrands } from "src/redux/actions/brand.action";
import { getDepts } from "src/redux/actions/department.action";
import CustomSelectInput from "src/components/inputs/CustomSelectInput";
import SearchIcon from "@material-ui/icons/Search";
import { getYearList } from "src/redux/actions/purchaseRequest.action";
import { Alert, AlertTitle } from "@material-ui/lab";
import { hasRole } from "src/utils/Auth";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    lineHeight: "5ch",
    alignContent: "center",
    minWidth: "20ch",
  },
}));

export default function BudgetCodeSearchFormComponent({
  onSubmit,
  roles,
  departments,
}) {
  const classes = useStyles();

  const {
    result: { companyid, countryid },
  } = useSelector((state) => state.loginReducer);
  const { authorizePR } = useSelector((state) => state.authorizationReducer);

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <div className={classes.modal}>
      <Formik
        initialValues={{
          USER_ID: "",
          USER_NAME: "",
          DATA_UPDATE_STATUS: "",
          STATUS: "",
          DEPARTMENT: "",
        }}
        onSubmit={(values, { setSubmitting }) => {
          // search
          onSubmit(values);
          setSubmitting(false);
        }}
        render={({
          submitForm,
          resetForm,
          isSubmitting,
          touched,
          errors,
          values,
          setFieldValue,
        }) => (
          <>
            <Box display="flex" justifyContent="space-between" flex={1}>
              <Box>
                <Field
                  component={TextField}
                  name="USER_ID"
                  label="User ID"
                  size="small"
                  error={Boolean(
                    errors.USER_ID && touched.USER_ID && errors.USER_ID
                  )}
                  onChange={(e) => {
                    setFieldValue("USER_ID", e.target.value);
                    submitForm();
                  }}
                />
              </Box>
              <Box>
                <Field
                  component={TextField}
                  name="USER_NAME"
                  label="User Name"
                  size="small"
                  error={Boolean(
                    errors.USER_NAME && touched.USER_NAME && errors.USER_NAME
                  )}
                  onChange={(e) => {
                    setFieldValue("USER_NAME", e.target.value);
                    submitForm();
                  }}
                />
              </Box>
              <Box>
                <FormControl
                  error={Boolean(
                    errors.DATA_UPDATE_STATUS &&
                      touched.DATA_UPDATE_STATUS &&
                      errors.DATA_UPDATE_STATUS
                  )}
                  fullWidth
                  style={{
                    minWidth: 200,
                  }}
                >
                  <InputLabel id="select-year-label">
                    Data Update Status
                  </InputLabel>
                  <Field
                    component={CustomSelectInput}
                    name="DATA_UPDATE_STATUS"
                    label="Data Update Status"
                    labelId="select-role-label"
                    size="small"
                    error={Boolean(
                      errors.DATA_UPDATE_STATUS &&
                        touched.DATA_UPDATE_STATUS &&
                        errors.DATA_UPDATE_STATUS
                    )}
                    onChange={(e) => {
                      submitForm();
                    }}
                    displayEmpty
                  >
                    <MenuItem value={"ALL"}>All</MenuItem>
                    <MenuItem value={"NEW"}>New</MenuItem>
                    <MenuItem value={"UPDATE"}>Update</MenuItem>
                    <MenuItem value={"NO"}>No</MenuItem>
                  </Field>
                </FormControl>
              </Box>
              <Box>
                <FormControl
                  error={Boolean(
                    errors.STATUS && touched.STATUS && errors.STATUS
                  )}
                  fullWidth
                  style={{
                    minWidth: 200,
                  }}
                >
                  <InputLabel id="select-year-label">Status</InputLabel>
                  <Field
                    component={CustomSelectInput}
                    name="STATUS"
                    label="Status"
                    labelId="select-role-label"
                    size="small"
                    error={Boolean(
                      errors.STATUS && touched.STATUS && errors.STATUS
                    )}
                    onChange={(e) => {
                      submitForm();
                    }}
                    displayEmpty
                  >
                    <MenuItem value={"ALL"}>All</MenuItem>
                    <MenuItem value={"ACTIVE"}>Active</MenuItem>
                    <MenuItem value={"INACTIVE"}>Inactive</MenuItem>
                  </Field>
                </FormControl>
              </Box>
              <Box>
                <FormControl
                  error={Boolean(
                    errors.DEPARTMENT && touched.DEPARTMENT && errors.DEPARTMENT
                  )}
                  fullWidth
                  style={{
                    minWidth: 200,
                  }}
                >
                  <InputLabel id="select-year-label">Department</InputLabel>
                  <Field
                    component={CustomSelectInput}
                    name="DEPARTMENT"
                    label="Status"
                    labelId="select-role-label"
                    size="small"
                    error={Boolean(
                      errors.DEPARTMENT &&
                        touched.DEPARTMENT &&
                        errors.DEPARTMENT
                    )}
                    onChange={(e) => {
                      submitForm();
                    }}
                    displayEmpty
                  >
                    <MenuItem key={1} value={"ALL"}>
                      All
                    </MenuItem>
                    {departments &&
                      departments.map((d) => (
                        <MenuItem key={d.DEPART_CODE} value={d.DEPART_CODE}>
                          {d.DEPART_NAME}
                        </MenuItem>
                      ))}
                  </Field>
                </FormControl>
              </Box>
            </Box>
            {/* <Grid container spacing={1}>
              <Grid item md={6} xs={12}>
                <FormControl
                  fullWidth
                  error={Boolean(errors.ROLE && touched.ROLE && errors.ROLE)}
                >
                  <InputLabel id="select-year-label">
                    Please Select Role
                  </InputLabel>
                  <Field
                    component={CustomSelectInput}
                    name="ROLE"
                    label="Role"
                    labelId="select-role-label"
                    size="small"
                    error={Boolean(errors.ROLE && touched.ROLE && errors.ROLE)}
                    onChange={() => {}}
                    displayEmpty
                  >
                    {renderRoles()}
                  </Field>
                </FormControl>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box display="flex">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={submitForm}
                    disabled={isSubmitting}
                    fullWidth
                  >
                    Update Role By Selection
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    onClick={(e) => {
                      e.preventDefault();
                      resetForm({});
                    }}
                    disabled={isSubmitting}
                  >
                    Clear
                  </Button>
                </Box>
              </Grid>
            </Grid> */}
          </>
        )}
      />
    </div>
  );
}
